import { useSubscriptionStore } from "@/store/subscription-store"

async function handleMembershipsAddedEvent() {
  await useSubscriptionStore().loadActiveCompanySubscription()
}

export default {
  handleMembershipsAddedEvent
}
